import React, { useState } from "react";
import styled from "@emotion/styled";
import UserImage from "@components/item/UserImage";
import { useTranslation } from "react-i18next";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import StarRating from "@components/item/StarRating";
import { useNavigate } from "react-router-dom";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import useUserInfoStore from "@store/useUserInfoStore";

const Container = styled.div<{ button?: boolean }>(({ button, theme }) => ({
  position: "relative",
  display: "flex",
  gap: "1rem",
  alignItems: "flex-start",
  border: button ? `1px solid ${theme.color.border_gray}` : "none",
  padding: button ? "1rem" : "",
}));

const InfoWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});

const Membership = styled.div(({ theme }) => ({
  display: "inline-block",
  fontSize: "1rem",
  lineHeight: "1.2rem",
  color: theme.color.black,
  backgroundColor: theme.color.mint,
  padding: "0.6rem 0.8rem",
  borderRadius: "0.4rem",
}));

const NicknameBox = styled.div<{ button?: boolean }>(({ theme, button }) => ({
  display: "flex",
  alignItems: button ? "flex-end" : "center",
  gap: "1rem",
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.medium,
  lineHeight: "2.4rem",

  ".sell_count": {
    color: "#969696",
    fontWeight: theme.fontWeight.regular,
    fontSize: "1.2rem",
    lineHeight: "2rem",
  },
}));

const Email = styled.span(({ theme }) => ({
  color: theme.color.light_gray,
  fontWeight: theme.fontWeight.medium,
}));

const EditButton = styled.button({
  display: "flex",
});

const ButtonIcon = styled.button({
  position: "absolute",
  top: "50%",
  right: "2rem",
  transform: "translateY(-50%)",
  backgroundColor: "transparent",
  border: "none",
});

const SellerInfoCard = ({
  myPage,
  button,
  sellerId,
  noButton,
}: {
  myPage?: boolean;
  button?: boolean;
  sellerId: number;
  noButton?: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const { userInfo } = useUserInfoStore();

  const { getSellerInfo, getMemberSubscription } = useApiRequest();

  const { data: sellerInfo, isLoading: userLoading } = useQuery({
    queryKey: ["sellerInfo", sellerId],
    queryFn: () => getSellerInfo(sellerId),
  });

  const handleNavigatePage = () => {
    if (userInfo?.id === sellerId) {
      navigate("/my-page");
    } else {
      navigate(`/seller/${sellerId}`);
    }
  };

  const { data: subscribeDetail } = useQuery({
    queryKey: ["subscribeDetail"],
    queryFn: getMemberSubscription,
  });

  return userLoading ? (
    <></>
  ) : (
    // 버튼이있으면 네비게이트 함수실행
    <Container
      button={button}
      onClick={button ? handleNavigatePage : undefined}>
      <UserImage src={sellerInfo?.profile_image} />
      <InfoWrapper>
        <NicknameBox button={button}>
          {!!subscribeDetail?.is_subscribed && myPage && (
            <Membership>{t("회원")}</Membership>
          )}

          {sellerInfo?.nickname}

          {button && (
            <span className="sell_count">
              {t("판매중인 상품")}({sellerInfo?.total_product_count})
            </span>
          )}
        </NicknameBox>

        <StarRating
          rate={sellerInfo?.rate}
          readonly
          reviewCnt={sellerInfo?.review_count}
          onClick={noButton ? () => {} : () => handleNavigatePage()}
        />
      </InfoWrapper>

      {button && (
        <ButtonIcon>
          <Image
            src={theme.image.arrow_right.default}
            width="1.6rem"
            height="1.6rem"
          />
        </ButtonIcon>
      )}
    </Container>
  );
};

export default SellerInfoCard;
